import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'filter',
  pure: true,
  standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(value: any[], filterStr: string, propName: string): any {
    if (filterStr == undefined || filterStr == '') {
      return value;
    }


    const resultArray = value.filter((item :any)=> item[propName]
      .toLowerCase()
      .indexOf(filterStr.toLowerCase()) >= 0);

    return resultArray;
  }
}
